// Configuration du module VideoModule
import type { ComponentMetadata } from '../../G&CSCM/Core/types';

export const VideoModuleConfig: ComponentMetadata = {
    name: 'VideoModule',
    displayName: 'Lecteur Vidéo HLS',
    description: 'Lecteur vidéo avec support HLS et qualités adaptatives',
    category: 'Media',
    defaultParams: {
        controls: true,
        autoPlay: false
    },
    paramDefinitions: {
        fileId: {
            type: 'string',
            label: 'ID Fichier API',
            description: 'ID du fichier vidéo dans l\'API (optionnel)',
            file_types: 'File(video)',
            editable_by_dev: true,
            editable_by_user: true  // Les utilisateurs ne peuvent pas changer l'ID du fichier vidéo
        },
        src: {
            type: 'string',
            label: 'Source locale',
            description: 'Chemin vers la vidéo locale (optionnel)',
            editable_by_dev: true,
            editable_by_user: false  // Les utilisateurs ne peuvent pas changer la source
        },
        poster: {
            type: 'string',
            label: 'Image poster',
            description: 'Image affichée avant la lecture',
            file_types: 'File(image)',
            editable_by_dev: true,
            editable_by_user: true  // Les utilisateurs peuvent changer l'image poster
        },
        autoPlay: {
            type: 'boolean',
            label: 'Lecture automatique',
            description: 'Démarrer automatiquement la lecture',
            editable_by_dev: true,
            editable_by_user: true  // Les utilisateurs peuvent contrôler l'autoplay
        },
        controls: {
            type: 'boolean',
            label: 'Contrôles',
            description: 'Afficher les contrôles de lecture',
            editable_by_dev: true,
            editable_by_user: true  // Les utilisateurs peuvent contrôler l'affichage des contrôles
        }
    },
    outsideGrid: false,
    defaultEnabled: true
};

export default VideoModuleConfig;


